import type { FunctionComponent } from "react";

import Bulb from "./bulb.png";
import Rocket from "./rocket.png";
import SeaAnimals from "./sea-animals.png";
import {
  BottomLeftContainer,
  BottomRightContainer,
  Container,
  IconsContainer,
  TopRightContainer,
} from "./styles";

export const SteamStudioDesktopIcons: FunctionComponent = () => (
  <Container>
    <IconsContainer>
      <TopRightContainer>
        <img src={Bulb.src} />
      </TopRightContainer>
      <BottomLeftContainer>
        <img src={Rocket.src} />
      </BottomLeftContainer>
      <BottomRightContainer>
        <img src={SeaAnimals.src} />
      </BottomRightContainer>
    </IconsContainer>
  </Container>
);

SteamStudioDesktopIcons.displayName = "SteamStudioDesktopIcons";
